import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import Image from 'components/image/Image';
import useLocales from 'hooks/useLocales';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './index.scss';

const LanguageToggle = () => {
  const { tenantSiteLanguages } = useTenantInfo();
  const { onChangeLang, currentLang, allLang } = useLocales();
  const [language, setLanguage] = useState<string>(currentLang?.value || 'en');

  if (!tenantSiteLanguages || tenantSiteLanguages.length <= 1) {
    return null;
  }

  const handleLanguageChange = (
    event: React.MouseEvent<HTMLElement>,
    newLanguage: string | null
  ) => {
    if (newLanguage !== null) {
      setLanguage(newLanguage);
      onChangeLang(newLanguage);
    }
  };

  return (
    <div className="language-toggle-container">
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleLanguageChange}
        aria-label="language"
        size="small"
        sx={{ mt: 2 }}
      >
        {allLang.map((lang) => (
          <ToggleButton
            key={lang.value}
            value={lang.value}
            aria-label={lang.label}
            sx={{ borderRadius: '12px' }}
          >
            <Image
              name={lang.icon1}
              width={16}
              height={16}
              style={{ marginRight: '4px' }}
            />
            {lang.value.toUpperCase()}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default LanguageToggle;
